import DefaultTable from '../DefaultTable/DefaultClass'
import {commonTrueFalse} from "../../_constants/choices";

/*
brands_country:null
id:2954
name:"Samange"
name_clean:"Samange"
original_brand:false
seo_description:""
source"samangeitaly@gmail.com"
synonyms_search:"саманж --------- саманж"
 */
class Brands extends DefaultTable {
    constructor(props) {
        super(props)

        this.filters_aside = [
            {
                name: 'original_brand',
                type: "TrueFalseFilters",
                parameters: [],
            },
        ]

        this.filters_aside = [...this.default_filters_aside, ...this.filters_aside]

        this.fields_data = [
            {
                tab: "COMMON",
                dataTab: [
                    {
                        box: [
                            {
                                name: 'name',
                                type: 'text',
                                show_type: 'TextFieldBold',
                                edit_type: 'TranslatableInputs',
                                type_ext: {locale: true},
                                //formTab: 'Common2222',
                                read_only: false
                            },
                            {
                                name: 'name_clean',
                                type: 'text',
                                show_type: 'TextField',
                                edit_type: 'TranslatableInputs',
                                type_ext: {locale: true},
                                //formTab: 'Common2222',
                                read_only: false
                            },
                        ]
                    },
                    {
                        box: [
                            {
                                name: 'seo_description',
                                type: 'text',
                                show_type: 'TextField',
                                edit_type: 'TranslatableInputs',
                                type_ext: {locale: true},
                                //formTab: 'Common2222',
                                read_only: false
                            },
                            {
                                name: 'synonyms_search',
                                type: 'text',
                                show_type: 'TextField',
                                edit_type: 'TextInput',
                                read_only: false
                            },
                        ]
                    },
                    {
                        box: [
                            {
                                name: 'original_brand',
                                type: 'bool',
                                show_type: 'SelectAndSaveChoices',
                                edit_type: 'BooleanInput',
                                type_ext: {choices: commonTrueFalse, reference: 'Brands', width: '3em'},
                                read_only: false
                            },
                            {
                                name: 'brands_country',
                                type: 'text',
                                show_type: 'TextField',
                                edit_type: 'TextInput',
                                read_only: false
                            },
                            {
                                name: 'uuid',
                                type: 'text',
                                show_type: 'TextField',
                                edit_type: '',
                                read_only: false
                            },

                        ]
                    },
                ]
            },
        ]
        this.fields_data = [...this.default_fields_data, ...this.fields_data]

        this.related_table = [
            {
                name: 'BrandsSynonyms',
                filters: 'brand',
            },
            {
                name: 'BrandsReplacement',
                filters: 'brand',
            },
            {
                name: 'DiscountCustomerBrand',
                filters: 'brand',
            },
            {
                name: 'Suffixes',
                filters: 'brand',
            },
            {
                name: 'Prefixes',
                filters: 'brand',
            },
            {
                name: 'BrandImage',
                filters: 'brand',
            },

        ]

    }
}

export default Brands